export const limit = (value, min = Infinity, max = Infinity) => {
	return Math.max(Math.min(value, max), min);
};
